import React, { useState, useEffect } from "react";
import "./formSelfcareAttribute.css";
import { Form, Input, Button, Typography, Space, Row, Col, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import DraggableBehaviors from "../draggableBehaviors/DraggableBehaviors";
import OrderingAPI from "../../utils/OrderingAPI";

const { Text } = Typography;

const FormSelfcareAttribute = (props) => {
    const [isEditing, setIsEditing] = useState(false);

    const handleEditClick = () => setIsEditing(true);
    const handleSaveClick = () => {
        setIsEditing(false);
        props.saveSelfcareAttribute();
    };

    const handleCreateClick = () => {
        props.saveSelfcareAttribute();
    };

    useEffect(() => {
        setIsEditing(false);
    }, [props.scaId]);

    const handleBehaviorChange = (index, value) => {
        const updatedBehaviors = [...(props.scaBehaviors || [])];
        const current = updatedBehaviors[index];
        if (current && typeof current === "object") {
            updatedBehaviors[index] = { ...current, sbe_behavior: value };
        } else {
            updatedBehaviors[index] = { sbe_id: null, sbe_behavior: value, sbe_reversed: false };
        }
        props.setScaBehaviors(updatedBehaviors);
    };

    const handleBehaviorReversedChange = (index, checked) => {
        const updatedBehaviors = [...(props.scaBehaviors || [])];
        const current = updatedBehaviors[index];
        if (current && typeof current === "object") {
            updatedBehaviors[index] = { ...current, sbe_reversed: checked };
        } else {
            updatedBehaviors[index] = { sbe_id: null, sbe_behavior: "", sbe_reversed: checked };
        }
        props.setScaBehaviors(updatedBehaviors);
    };

    const addBehavior = () => {
        const updatedBehaviors = [...(props.scaBehaviors || [])];
        updatedBehaviors.push({ sbe_id: null, sbe_behavior: "", sbe_reversed: false });
        props.setScaBehaviors(updatedBehaviors);
    };

    const removeBehavior = (index) => {
        const updatedBehaviors = (props.scaBehaviors || []).filter((_, i) => i !== index);
        props.setScaBehaviors(updatedBehaviors);
    };

    const handleSaveBehaviorOrder = async (orderData) => {
        try {
            await OrderingAPI.updateSelfcareBehaviorsOrder(orderData);
        } catch (error) {
            console.error("Error al guardar orden:", error);
        }
    };

    const getBehaviorsWithIds = () => {
        return props.scaBehaviors || [];
    };

    return (
        <Form layout="horizontal">
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}>
                    <Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Nombre:</Text>
                </Col>
                <Col span={20}>
                    {isEditing || props.newSelfcareAttribute ? (
                        <Input
                            value={props.scaAttribute}
                            onChange={(e) => props.setScaAttribute(e.target.value.toUpperCase())}
                        />
                    ) : (
                        <Text>{props.scaAttribute || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}>
                    <Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Descripción:</Text>
                </Col>
                <Col span={20}>
                    {isEditing || props.newSelfcareAttribute ? (
                        <Input
                            value={props.scaDescription}
                            onChange={(e) => props.setScaDescription(e.target.value.toUpperCase())}
                        />
                    ) : (
                        <Text>{props.scaDescription || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
                <Col span={4}>
                    <Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Comportamientos:</Text>
                </Col>
                <Col span={20} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {!props.newSelfcareAttribute && props.scaId && (props.scaBehaviors || []).length > 0 && props.onDeleteAllBehaviors && (
                        <Popconfirm
                            title="¿Eliminar todos los comportamientos?"
                            description="Esta acción eliminará todos los comportamientos de este atributo. No se puede deshacer."
                            onConfirm={() => props.onDeleteAllBehaviors(props.scaId)}
                            okText="Sí, eliminar"
                            cancelText="Cancelar"
                            okButtonProps={{ danger: true }}
                        >
                            <Button danger size="small" icon={<DeleteOutlined />}>
                                Eliminar todos los comportamientos ({(props.scaBehaviors || []).length})
                            </Button>
                        </Popconfirm>
                    )}
                </Col>
            </Row>

            <DraggableBehaviors
                behaviors={getBehaviorsWithIds()}
                isEditing={isEditing || props.newSelfcareAttribute}
                onBehaviorChange={handleBehaviorChange}
                onBehaviorToggleReversed={handleBehaviorReversedChange}
                onBehaviorAdd={addBehavior}
                onBehaviorDelete={removeBehavior}
                onSaveOrder={handleSaveBehaviorOrder}
                attributeId={props.scaId}
                attributeType="selfcare"
            />

            <Row justify="end" style={{ marginTop: 20 }}>
                <Space>
                    {props.newSelfcareAttribute ? (
                        <Button type="primary" onClick={handleCreateClick}>
                            Guardar
                        </Button>
                    ) : isEditing ? (
                        <>
                            <Button type="primary" onClick={handleSaveClick}>
                                Guardar
                            </Button>
                            <Button onClick={() => setIsEditing(false)}>Cancelar</Button>
                        </>
                    ) : (
                        <Button type="default" onClick={handleEditClick}>
                            Editar
                        </Button>
                    )}
                </Space>
            </Row>
        </Form>
    );
};

export default FormSelfcareAttribute;
